export const HOME_ROUTE = "/";
export const PROFILE_ROUTE = "/profile";
export const MY_LOOKS_ROUTE = "/my-looks";
export const VIBES_ROUTE = "/vibes";
export const LOOK_POSTS_ROUTE = "/look-posts-route";
export const POSTS_ROUTE = "/leaderboard";
export const CREATE_ROUTE = "/create";
export const PRIVATE_INVITE_ROUTE = "private/invite";
